// extracted by mini-css-extract-plugin
export var bodyRow = "_eb-d";
export var cardColumns = "_eb-e";
export var ellipsesOverflow = "_eb-2";
export var flatBottomCorners = "_eb-3";
export var flatTopCorners = "_eb-4";
export var headerActionsDropdown = "_eb-f";
export var headerBottomRow = "_eb-c";
export var headerTopRow = "_eb-b";
export var orderDetailsWrapper = "_eb-0";
export var orderInfoContainer = "_eb-1";
export var productDetails = "_eb-9";
export var productImage = "_eb-5";
export var responsiveTable = "_eb-8";
export var shipmentContainer = "_eb-a";
export var tableBottomLeft = "_eb-6";
export var tableBottomRight = "_eb-7";
export var trackingLink = "_eb-g";